import { useNavigate } from 'react-router-dom';
import { IHeaderProps } from '@/interface';
import { Picture } from '@/components/atoms/Picture';
import { logout } from '@/utils/logout';
import { UserOutlined } from '@ant-design/icons';
import { useAppDispatch } from '@/app/hooks';
import { useTranslation } from 'react-i18next';
import { signOut } from 'firebase/auth';
import { auth } from '@/services/firebase';
import { useAuthStore } from '@/zustand/useAuthGoogle';
import { setFavorites } from '@/features/favorite/favoriteSlice';
import './header.scss';

export const Header = ({ avatar, name }: IHeaderProps) => {
  const dispatch = useAppDispatch();
  const { user, setUser: resetUser } = useAuthStore((state) => state);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const logoutUser = () => {
    if (user) {
      dispatch(setFavorites([]));
    }
    logout(dispatch);
    signOut(auth);
    resetUser(null);
    navigate('/');
  };

  return (
    <header className='a-header'>
      <h1 className='a-header__title'>{t('home.title')}</h1>
      {avatar ? (
        <Picture
          url={avatar}
          classPicture='a-header__avatar'
          isBorderRadius={true}
          alt={name}
          onClick={() => logoutUser()}
        />
      ) : (
        <UserOutlined className='a-header__icon' onClick={() => logoutUser()} />
      )}
    </header>
  );
};
